import { FC } from 'react';

import { PlayerApiError } from '@/scenarios/legacy-player/types/error';
import { useOnContentImpression } from '@/scenarios/legacy-player/hooks/useOnContentImpression';
import { useOnFinish } from '@/scenarios/legacy-player/hooks/useOnFinish';
import { useOnReady } from '@/scenarios/legacy-player/hooks/useOnReady';
import { useSetNativeSubtitlesVisibility } from '@/scenarios/legacy-player/hooks/useSetNativeSubtitlesVisibility';

import { useErrorInfo } from '../../../hooks/player-instance/use-error-info';
import { hidePlayerIframeToScreenReaders } from '../../../utils/hide-player-iframe-to-screen-readers';
import { useVodActiveTabController } from '../../../../vod-player/hooks/use-vod-active-tab-controller';
import { useSoundPreferencesWatcher } from '../../../hooks/config/use-sound-preferences';
import { useOnError } from '../../../hooks/controller/use-on-error';

interface Props {
    onContentImpression: () => void;
    onFinish?: () => void;
    onError?: (error: PlayerApiError) => void;
}

export const TrailerPlayerController: FC<Props> = ({ onContentImpression, onFinish, onError }) => {
    useOnContentImpression(onContentImpression);
    useOnError(onError);
    useOnFinish(onFinish);
    useErrorInfo();
    useOnReady(hidePlayerIframeToScreenReaders);
    useVodActiveTabController();
    useSetNativeSubtitlesVisibility(false);

    useSoundPreferencesWatcher();

    return null;
};
